define('file-utils',{
	formatFileSize: function(bytes) {
		if (bytes < 1000) {
			return bytes + ' Byte';
		}
		if (bytes < 1000000) {
			return Math.round(bytes / 1000) + " KB";
		}
		if (bytes < 1000000000) {
			return Math.round(bytes / 1000000) + " MB";
		}
		return Math.round(bytes / 1000000000) + " GB";
	}
});

